// extracted by mini-css-extract-plugin
export default {"recipe":"recipe_recipe__FSIxP","image":"recipe_image__OoOvY"};